import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DeviceCheck } from './services/Routing/Guards/DeviceCheck/device-check';
import { InspectionCheck } from './services/Routing/Guards/InspectionCheck/inspection-check';
import { AppThemeResolverService } from './services/Routing/Resolvers/AppTheme/app-theme-resolver.service';
import { InspectionInitResolverService } from './services/Routing/Resolvers/InspectionInit/inspection-init-resolver.service';
import { InspectionOrientationResolverService } from './services/Routing/Resolvers/InspectionOrientation/inspection-orientation-resolver.service';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'home',
    loadChildren: () =>
      import('./pages/general/home/home.module').then((m) => m.HomePageModule),
    canActivate: [
      DeviceCheck,
      InspectionCheck,
    ],
  },
  {
    path: 'start/:hash',
    loadChildren: () =>
      import('./pages/general/start/start.module').then(
        (m) => m.StartPageModule
      ),
    canActivate: [
      DeviceCheck,
      InspectionCheck,
    ],
  },
  {
    path: 'inspection',
    loadChildren: () =>
      import('./layouts/inspection-layout/inspection-layout.module').then(
        (m) => m.InspectionLayoutModule
      ),
    resolve: {
      currentIdx: InspectionInitResolverService,
      theme: AppThemeResolverService,
    },
    canActivate: [
      DeviceCheck,
      InspectionCheck,
    ],
  },
  {
    path: 'desktop',
    loadChildren: () =>
      import('./pages/desktop/desktop.module').then((m) => m.DesktopPageModule),
  },
  {
    path: 'reset',
    loadChildren: () =>
      import('./pages/reset/reset.module').then((m) => m.ResetPageModule),
  },
  {
    path: 'error',
    loadChildren: () =>
      import('./pages/general/error/error.module').then(
        (m) => m.ErrorPageModule
      ),
    resolve: {
      orientation: InspectionOrientationResolverService
    },
  },
  {
    path: 'end-inspection',
    loadChildren: () =>
      import('./pages/general/end-inspection/end-inspection.module').then(
        (m) => m.EndInspectionPageModule
      ),
  },
  // El wildcard tiene que ser el último
  {
    path: '**',
    redirectTo: 'home',
  },
];
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
